(function (angular) {
    'use strict';

    angular.module('appMessaging')

        /**
         *
         */
        .factory('authenticationService',
            ['$http', '$q', 'jwtService', 'portalConfig',
                function ($http, $q, jwtService, portalConfig) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        getAuthConfig: getAuthConfig,
                        setAuthConfig: setAuthConfig
                    };

                    return fac;


                    /**
                     * GET "/apispace/{id}/auth"
                     * @param {string} id - the api space Id
                     */
                    function getAuthConfig(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/auth")
                            .then(getAuthConfigComplete)
                            .catch(getAuthConfigFailed);

                        function getAuthConfigComplete(response) {
                            return response.data;
                        }

                        function getAuthConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT "/apispace/{id}/auth"
                     * @param {string} id - the api space Id
                     * @param {Object} config - the api space confif
                     */
                    function setAuthConfig(id, config) {

                        return $http.put(urlBase + "/apispaces/" + id + "/auth", config)
                            .then(setAuthConfigComplete)
                            .catch(setAuthConfigFailed);

                        function setAuthConfigComplete(response) {
                            return response.data;
                        }

                        function setAuthConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }


                }]);

})(window.angular);
